jQuery(document).ready(function ($) {
  if (window.innerWidth < 767) {
    $("[data-slider-id]").each(function () {
      var $slider = $(this);
      var sliderId = $slider.data("slider-id");
      var controlsId = $slider.data("controls-id");
      var $controls = $("#" + controlsId);

      if ($slider.hasClass("slick-initialized")) return; // prevent double init

      $slider.slick({
        arrows: true,
        dots: true,
        infinite: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        customPaging: function () {
          return '<span class="slick-line"></span>';
        },
        appendArrows: $controls,
        appendDots: $controls
      });
    });
  }
});
